import SurvivorUI from './SurvivorUI'
export default SurvivorUI;